<template>
  <div>
    <div class="official-website-container">
      <header class="header-section">
        <div class="header-content">
          <h1 class="header-title">中物鉴智（成都）科技成果评价有限公司</h1>
          <div class="header-divider"></div>
          <div class="header-desc">
            <p style="text-indent: 40px;">
              中物鉴智（成都）科技成果评价有限公司是全国领先的科技成果评估评价机构，专注于概念验证、技术尽调、机构评估、人才评价、成果评价等专业服务。公司深度融合前沿技术与专业经验，自主研发科技成果转化垂类大模型——智鉴天平，融合通义千问语义解析、DeepSeek逻辑推理引擎及中物鉴智行业数据库，构建了“科技情报分析（论文+专利+课题）+人工分析+专家论证”三级验证体系，可对科技成果转化项目进行价值与价格智能评价，并自动生成评估报告。
            </p>
            <p style="text-indent: 40px;">
              公司是全国科技评估与管理研究会会员单位，承担了GB/T 42776-2023《科技评估分类》、GB/T 44731-2024《科技成果评估规范》 等国家标准的试点工作，严格按照国家标准与行业通识开展评价服务。
            </p>
            <p style="text-indent: 40px;">
               公司已为地方政府、高校、科研院所、央国企及民营头部企业等1000余个项目提供成果评价、概念验证、技术评估、验收结题、奖励培育等服务；完成重庆市新型研发机构、成都高新区“岷山行动”计划等100余个重大项目的立项评审、中期评估、结题验收；为清华大学、北京大学等知名高校的50余个高层次人才团队开展技术评估与场景验证；为国家电网、中国石油、蜀道集团等央国企提供技术难题攻关与技术创新体系建设服务。
            </p>
            <p style="text-indent: 40px;">
              公司拥有超20人的专业化团队，其中博士1人、硕士5人、工程师4人，并构建了由10000余位知名院士、专家组成的专家库，可胜任多领域评估工作。所评价项目获国家、省部级科技进步奖100余项，有力支撑了40余家企业上市、上板、上新，评估评价项目累计获得政策补贴、投融资超10亿元。
            </p>
          </div>
        </div>
      </header>

      <div style="width: 100%;background: #fff;padding: 0px 24px;padding-top: 40px;">
        <section>
          <h2 class="section-title">资质荣誉</h2>
          <div class="awards-wrap">
            <div class="awards-prev" @click="scrollAwards('left')">
              <i class="el-icon-arrow-left"></i>
            </div>
            <div class="awards-next" @click="scrollAwards('right')">
              <i class="el-icon-arrow-right"></i>
            </div>

            <div class="awards-scroll" ref="awardsScroll">
              <div class="awards-list">
                <div class="award-card" v-for="(item, index) in 8" :key="index">
                  <el-image style="height: 100%;width: 100%;object-fit: cover;border-radius: 8px;"
                    :src="require(`@/assets/images/unit${index + 1}.jpg`)"
                    :preview-src-list="[require(`@/assets/images/unit${index + 1}.jpg`)]">
                  </el-image>
                </div>
              </div>
            </div>
          </div>
          <div class="awards-text-desc">
            成都市技术经理人协会理事单位、成都市技术转移联盟理事单位、成都市概念验证中心、IPO加速孵化平台金牛工作站、全国科技评估标准化试点单位（二批次）、中国科技评估与成果管理研究会会员单位、高新技术企业、中国科技评估与成果管理研究会会员代表
          </div>

        </section>

        <!-- 核心优势 -->
        <!-- <div style="text-align: center;background: rgba(69, 155, 248, 0.1);">
        <img style="         
              width: 100%;           
              object-fit: contain;" src="@/assets/images/hexing.png"/>
      </div> -->
        <advantage></advantage>
        <!-- 合作伙伴 -->
        <!-- <div style="text-align: center;background: rgba(69, 155, 248, 0.1);margin-top: 20px;">
        <img style="          
              width: 100%;           
              object-fit: contain;" src="@/assets/images/hezuo.png"/>
      </div> -->
        <cooperation></cooperation>
        <div style="text-align: left;" class="awards-text-desc">
          清华大学北京大学 四川大学 电子科技大学 西南交通大学 西南石油大学 成都中医药大学 四川农业大学 中国科学院 成都理工大学
            中国工程物理研究院
            成都大学
            成都工贸职业学院
          国家电网
          中国石油
          中国航天
          中国能建
          中国电建
          中国电科
          中国生物
          长江电力
          蜀道集团
          四川路桥
          成都轨道交通
          川润股份
          川投能源
          雅砻江水电
          九洲电器
          卡诺普自动化
          润博科技
          重庆两江新区管理委员会
          宜宾市人民政府
          成都高新技术产业开发区管理委员会
          成都市双流区人民政府
          广汉市人民政府
          蒲江县人民政府
          什邡市人民政府
          德阳国家高新技术产业开发区管理委员会
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from '../../components/Footer.vue';
import advantage from './advantage.vue';
import cooperation from './cooperation.vue';
export default {
  name: "OfficialWebsite",
  data() {
    return {
      isExpertDragging: false,
      expertDragStartX: 0,
      expertScrollStartX: 0,
      expertLastDragX: 0,
      expertDragSpeed: 0,
      expertInertiaTimer: null,
      isPartnersDragging: false,
      partnersDragStartX: 0,
      partnersScrollStartX: 0,
      partnersLastDragX: 0,
      partnersDragSpeed: 0,
      partnersInertiaTimer: null
    };
  },
  components: {
    advantage,
    cooperation,
    Footer
  },
  methods: {
    scrollAwards(direction) {
      const scrollEl = this.$refs.awardsScroll;
      if (!scrollEl) return;
      const cardWidth = 340 + 20;
      scrollEl.scrollBy({
        left: direction === 'left' ? -cardWidth : cardWidth,
        behavior: 'smooth'
      });
    },

    getExpertField(index) {
      const fields = [
        "人工智能", "生物医药", "新材料", "新能源", "智能制造",
        "信息技术", "航空航天", "节能环保", "现代农业", "数字经济"
      ];
      return fields[index % fields.length];
    },
    getPartnerType(index) {
      const types = [
        "科研院校", "企业单位", "政府机构", "行业协会",
        "投资机构", "技术平台", "产业园区"
      ];
      return types[index % types.length];
    },
    handleExpertDragStart(e) {
      if (e.button !== 0) return;
      if (this.expertInertiaTimer) {
        cancelAnimationFrame(this.expertInertiaTimer);
        this.expertInertiaTimer = null;
      }
      this.isExpertDragging = true;
      const container = this.$refs.expertScroll;
      this.expertDragStartX = e.clientX;
      this.expertScrollStartX = container.scrollLeft;
      this.expertLastDragX = e.clientX;
      this.expertDragSpeed = 0;
      container.style.cursor = "grabbing";
      container.style.transition = "none";
      container.style.userSelect = "none";
    },
    handleExpertDragMove(e) {
      if (!this.isExpertDragging) return;
      e.preventDefault();
      const container = this.$refs.expertScroll;
      const currentX = e.clientX;
      const deltaX = currentX - this.expertDragStartX;
      container.scrollLeft = this.expertScrollStartX - deltaX;
      this.expertDragSpeed = currentX - this.expertLastDragX;
      this.expertLastDragX = currentX;
    },
    handleExpertDragEnd() {
      if (!this.isExpertDragging) return;
      this.isExpertDragging = false;
      const container = this.$refs.expertScroll;
      container.style.cursor = "grab";
      container.style.transition = "scroll-behavior 0.2s ease";
      this.startExpertInertiaScroll();
    },
    startExpertInertiaScroll() {
      const container = this.$refs.expertScroll;
      let speed = this.expertDragSpeed * 2.5;
      const friction = 0.95;
      const minSpeed = 0.3;

      const inertiaStep = () => {
        container.scrollLeft -= speed;
        speed *= friction;
        const maxScroll = container.scrollWidth - container.clientWidth;
        if (container.scrollLeft <= 0) {
          container.scrollLeft = 0;
          speed = 0;
        }
        if (container.scrollLeft >= maxScroll) {
          container.scrollLeft = maxScroll;
          speed = 0;
        }
        if (Math.abs(speed) > minSpeed) {
          this.expertInertiaTimer = requestAnimationFrame(inertiaStep);
        } else {
          container.style.scrollBehavior = "smooth";
          cancelAnimationFrame(this.expertInertiaTimer);
          this.expertInertiaTimer = null;
        }
      };
      if (Math.abs(speed) > minSpeed) {
        this.expertInertiaTimer = requestAnimationFrame(inertiaStep);
      }
    },
    handlePartnersDragStart(e) {
      if (e.button !== 0) return;
      if (this.partnersInertiaTimer) {
        cancelAnimationFrame(this.partnersInertiaTimer);
        this.partnersInertiaTimer = null;
      }
      this.isPartnersDragging = true;
      const container = this.$refs.partnersScroll;
      this.partnersDragStartX = e.clientX;
      this.partnersScrollStartX = container.scrollLeft;
      this.partnersLastDragX = e.clientX;
      this.partnersDragSpeed = 0;
      container.style.cursor = "grabbing";
      container.style.transition = "none";
      container.style.userSelect = "none";
    },
    handlePartnersDragMove(e) {
      if (!this.isPartnersDragging) return;
      e.preventDefault();
      const container = this.$refs.partnersScroll;
      const currentX = e.clientX;
      const deltaX = currentX - this.partnersDragStartX;
      container.scrollLeft = this.partnersScrollStartX - deltaX;
      this.partnersDragSpeed = currentX - this.partnersLastDragX;
      this.partnersLastDragX = currentX;
    },
    handlePartnersDragEnd() {
      if (!this.isPartnersDragging) return;
      this.isPartnersDragging = false;
      const container = this.$refs.partnersScroll;
      container.style.cursor = "grab";
      container.style.transition = "scroll-behavior 0.2s ease";
      this.startPartnersInertiaScroll();
    },
    startPartnersInertiaScroll() {
      const container = this.$refs.partnersScroll;
      let speed = this.partnersDragSpeed * 2.5;
      const friction = 0.95;
      const minSpeed = 0.3;

      const inertiaStep = () => {
        container.scrollLeft -= speed;
        speed *= friction;
        const maxScroll = container.scrollWidth - container.clientWidth;
        if (container.scrollLeft <= 0) {
          container.scrollLeft = 0;
          speed = 0;
        }
        if (container.scrollLeft >= maxScroll) {
          container.scrollLeft = maxScroll;
          speed = 0;
        }
        if (Math.abs(speed) > minSpeed) {
          this.partnersInertiaTimer = requestAnimationFrame(inertiaStep);
        } else {
          container.style.scrollBehavior = "smooth";
          cancelAnimationFrame(this.partnersInertiaTimer);
          this.partnersInertiaTimer = null;
        }
      };
      if (Math.abs(speed) > minSpeed) {
        this.partnersInertiaTimer = requestAnimationFrame(inertiaStep);
      }
    }
  },
  beforeDestroy() {
    if (this.expertInertiaTimer) cancelAnimationFrame(this.expertInertiaTimer);
    if (this.partnersInertiaTimer) cancelAnimationFrame(this.partnersInertiaTimer);
  }
};
</script>

<style scoped>
.header-section {
  width: 100%;
  background: #0a3d62;
  background-image: url('~@/assets/images/gxw1.jpg');
  background-size: cover;
  background-position: center;
  padding: 40px 140px;
  padding-top: 80px;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  height: 1000px;
}

.header-content {
  width: 100%;
  text-align: left;
}

.header-title {
  font-size: 48px;
  font-weight: bold;
  color: #ffffff;
  margin: 0 0 20px 0;
  line-height: 1.2;
}

.header-divider {
  width: 60%;
  height: 3px;
  background-color: #3498db;
  margin: 0 0 30px 0;
}

.header-desc {
  font-size: 20px;
  color: #ffffff;
  line-height: 2.2;
}

.header-desc p {
  margin: 0 0 15px 0;
}

.header-desc p:last-child {
  margin-bottom: 0;
}

.awards-text-desc {
  text-align: center;
  font-size: 16px;
  color: #0f4c81;
  line-height: 1.8;
  margin: 20px auto 40px;
  padding: 0 20px;
  max-width: 1400px;
  font-weight: 500;
}

.official-website-container {
  margin: 0 auto;
  padding: 0;
  font-family: "Microsoft Yahei", "PingFang SC", sans-serif;
  color: #222;
  background-color: #f5f7fa;
  margin-top: 0;
  max-width: 1920px;
}

.section-title {
  font-size: 3rem;
  color: #0f4c81;
  text-align: center;
  margin-bottom: 50px;
  position: relative;
  font-weight: 700;
}

.section-title::after {
  content: "";
  display: block;
  width: 100px;
  height: 4px;
  background-color: #1565c0;
  margin: 20px auto 0;
  border-radius: 2px;
}

.awards-wrap {
  position: relative;
  width: 100%;
  padding: 0 60px;
  box-sizing: border-box;
  max-width: 1600px;
  margin: 0 auto;
}

.awards-scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-behavior: smooth;
  padding: 30px 0;
}

.awards-scroll::-webkit-scrollbar {
  display: none;
}

.awards-list {
  display: flex;
  gap: 20px;
  width: fit-content;
  padding: 0 5px;
}

.awards-prev,
.awards-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(15, 76, 129, 0.8);
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;
}

.awards-prev:hover,
.awards-next:hover {
  background: rgba(21, 101, 192, 1);
  transform: translateY(-50%) scale(1.1);
}

.awards-prev {
  left: 10px;
}

.awards-next {
  right: 10px;
}

.award-card {
  flex: 0 0 340px;
  min-width: 280px;
  height: 240px;
  background: linear-gradient(180deg, #fff 0%, #f0f7ff 100%);
  border: 2px solid #1565c0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 18px rgba(21, 101, 192, 0.15);
  color: #0f4c81;
  font-size: 1.2rem;
  font-weight: 600;
}

.expert-pool-section {
  margin-bottom: 100px;
}

.expert-content {
  background: #fff;
  padding: 50px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  border: 1px solid #e8f0fe;
}

.expert-desc {
  font-size: 1.1rem;
  line-height: 1.9;
  margin-bottom: 40px;
  color: #333;
}

.expert-scroll-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 20px;
  margin-bottom: 40px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-behavior: smooth;
  touch-action: pan-x;
  -webkit-overflow-scrolling: touch;
  cursor: grab;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}

.expert-scroll-container::-webkit-scrollbar {
  display: none;
}

.expert-scroll-container,
.expert-scroll-container * {
  user-select: none !important;
  -webkit-user-select: none !important;
}

.expert-cards-list {
  display: flex;
  gap: 25px;
  width: fit-content;
  padding: 0 5px;
}

.expert-card {
  flex: 0 0 280px;
  width: 280px;
  height: 320px;
  background: linear-gradient(180deg, #fff 0%, #f8fbff 100%);
  border-radius: 12px;
  border: 2px solid #e8f0fe;
  box-shadow: 0 6px 20px rgba(21, 101, 192, 0.1);
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.expert-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 10px 30px rgba(21, 101, 192, 0.2);
  border-color: #1565c0;
}

.expert-avatar {
  width: 120px;
  height: 120px;
  margin-bottom: 20px;
  border: 3px solid #1565c0;
  border-radius: 50%;
  overflow: hidden;
}

.expert-info {
  text-align: center;
}

.expert-name {
  font-size: 1.4rem;
  color: #0f4c81;
  font-weight: 600;
  margin-bottom: 10px;
}

.expert-field {
  font-size: 1rem;
  color: #444;
  margin-bottom: 8px;
  line-height: 1.6;
}

.expert-exp {
  font-size: 0.95rem;
  color: #666;
  line-height: 1.6;
}

.expert-stats {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 40px;
  margin-top: 20px;
}

.stat-item {
  text-align: center;
}

.stat-num {
  display: block;
  font-size: 3rem;
  color: #0f4c81;
  font-weight: 800;
  margin-bottom: 15px;
  text-shadow: 0 2px 4px rgba(15, 76, 129, 0.1);
}

.stat-label {
  font-size: 1.1rem;
  color: #444;
  font-weight: 500;
}

.core-advantages-section {
  margin-bottom: 110px;
  margin-top: 40px;
}

.advantages-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 35px;
}

.advantage-item {
  background: linear-gradient(180deg, #fff 0%, #f8fbff 100%);
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(21, 101, 192, 0.1);
  transition: all 1s ease;
  border-left: 5px solid #1565c0;
}

.advantage-item:hover {
  box-shadow: 0 10px 30px rgba(21, 101, 192, 0.2);
  transform: translateY(-25px);
  border-left-color: #0f4c81;
}

.advantage-title {
  color: #0f4c81;
  font-size: 1.5rem;
  margin-bottom: 20px;
  font-weight: 600;
}

.advantage-desc {
  color: #444;
  line-height: 1.8;
  font-size: 1.05rem;
}

.partners-section {
  margin-bottom: 80px;
}

.partners-scroll-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 20px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-behavior: smooth;
  touch-action: pan-x;
  -webkit-overflow-scrolling: touch;
  cursor: grab;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}

.partners-scroll-container::-webkit-scrollbar {
  display: none;
}

.partners-scroll-container,
.partners-scroll-container * {
  user-select: none !important;
  -webkit-user-select: none !important;
}

.partners-cards-list {
  display: flex;
  gap: 25px;
  width: fit-content;
  padding: 0 5px;
  padding-top: 30px;
}

.partner-card {
  flex: 0 0 280px;
  width: 280px;
  height: 220px;
  background: linear-gradient(180deg, #fff 0%, #f0f7ff 100%);
  border: 2px solid #e8f0fe;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #0f4c81;
  font-size: 1.1rem;
  font-weight: 500;
  box-shadow: 0 6px 18px rgba(21, 101, 192, 0.1);
  transition: all 1s ease;
  box-sizing: border-box;
}

.partner-card:hover {
  border-color: #1565c0;
  box-shadow: 0 10px 25px rgba(21, 101, 192, 0.2);
  transform: translateY(-15px);
}

.partner-logo {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  margin-bottom: 15px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e8f0fe;
}

.partner-info {
  text-align: center;
}

.partner-name {
  font-size: 1.2rem;
  color: #0f4c81;
  font-weight: 600;
  margin-bottom: 8px;
}

.partner-type {
  font-size: 0.95rem;
  color: #666;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .header-section {
    padding: 20px;
  }

  .header-title {
    font-size: 28px;
  }

  .header-divider {
    width: 100%;
  }

  .header-desc {
    font-size: 15px;
  }
}
</style>